<script lang="ts">import { afterNavigate } from "$app/navigation";
import { page } from "$app/stores";
import { cfgOptimoveEnabled, cfgOptimoveTenantId, cfgOptimoveTenantToken } from "@infinitro/config";
let waitForSdkLoad = undefined;
const logNavigation = () => {
	console.log("optimove afterNavigate", $page);
};
afterNavigate(() => {
	if (!cfgOptimoveEnabled()) {
		console.log("optimove not enabled");
		return;
	}
	// @ts-ignore
	const sdk = globalThis.optimoveSDK;
	if (sdk && typeof sdk === "object") {
		logNavigation();
	} else {
		if (waitForSdkLoad) return;
		waitForSdkLoad = setInterval(() => {
			// @ts-ignore
			const sdk = globalThis.optimoveSDK;
			if (sdk && typeof sdk === "object") {
				clearInterval(waitForSdkLoad);
				waitForSdkLoad = undefined;
				logNavigation();
			}
		}, 1e3);
	}
});
</script>

<svelte:head>
	{#if cfgOptimoveEnabled()}
		<script
			async
			src="https://sdk.optimove.net/v2/websdk/?tenant_id={cfgOptimoveTenantId()}&tenant_token={cfgOptimoveTenantToken()}"
		></script>
	{/if}
</svelte:head>
